import { fetch } from "../lib/network";
import AppSettings from "../config";
import { GQL } from "../types/GQL";
import queryString from "query-string";
import decamelizeKeys from "decamelize-keys";
import { coreService } from "../services/coreService";
import { buildQuery } from "../lib/network";

export const fetchSearchCrmRequests = (headers: any) => (key: any, searchParams: any, cursor: any) =>
  buildQuery(
    coreService.crmSearchCreate(
      {
        ...searchParams,
        ...(cursor ? { searchAfter: cursor } : {}),
      },
      { headers },
    ),
    (response) => {
      return response.data;
    },
  );

export const fetchSearchCeCases = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) =>
  fetch(`${AppSettings.SEARCH_API_URL}/code`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());

export const fetchSearchPermits = (networkHeaders: any) => (key: any, searchParams: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/permits`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams)),
    headers: networkHeaders,
  }).then((res: any) => {
    if (res.status === 200) {
      return res.json();
    }
    if (res.error) throw new Error(res.error);
    throw new Error(`Query failed with status ${res.status}`);
  });
};

//For the renewals list of a campaign
export const fetchRenewalSearchPermits = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/permits`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res: any) => {
    if (res.status === 200) {
      return res.json();
    }
    if (res.error) throw new Error(res.error);
    throw new Error(`Query failed with status ${res.status}`);
  });
};

export interface PermitsSearchOptions {
  search_string: string;
  size: number;
}
export interface PermitsSearchData {
  id: number;
  permitId: number;
  city_id: number;
  elasticsearch_updated_at: string;
  external_id: string;
  campaign_id: number;
  staff_user_id: number;
  official_documents_template_id: number;
  applicant_id: number;
  creator_id: number;
  creator: {
    address: string;
    city: string;
    email: string;
    firstName: string;
    lastName: string;
    full_name: string;
    phone: string;
    state: string;
    type: string;
    zip: string;
    department_name: string;
    departmentId: number;
  };
  dateEntered: string;
  submitted_at: string;
  issued_at: string;
  started_at: string;
  expired_at: string;
  expired_notified_at: string;
  lapsed_notified_at: string;
  deleted_at: string;
  updated_at: string;
  created_at: string;
  dateLastUpdated: string;
  payment_requested_at: string;
  non_renewal_reason_submitted_at: string;
  invalid_date: string;
  primary_identifier: string;
  reservation_number: string;
  reservation_number_normalized: string;
  confirmation_number: string;
  confirmation_number_normalized: string;
  parent_id: number;
  parent_reservation_number: string;
  parent_reservation_number_normalized: string;
  status: string;
  permits_type_id: number;
  permits_type_name: string;
  total_fee_in_cents: number;
  total_active_fee_in_cents: number;
  total_paid_in_cents: number;
  total_pending: number;
  subtotal: number;
  total_fee_with_waives_in_cents: number;
  total_fees: number;
  total_paid: number;
  customFields: {
    extensionId: number;
    id: number;
    name: string;
    value_string: string;
    value_string_keyword: string;
    value_int: number;
    value_date: string;
  }[];
  contacts: {
    address: string;
    address2: string;
    city: string;
    company_name: string;
    connected_user_first_name: string;
    connected_user_id: number;
    connected_user_last_name: string;
    connected_user_sub_type: string;
    contact_type: string;
    country_id: string;
    email: string;
    first_name: string;
    full_name: string;
    is_applicant: boolean;
    is_submitter: boolean;
    last_name: string;
    license_number: string;
    permits_extension_def_id: string;
    phone: string;
    physical_address: string;
    physical_address2: string;
    physical_city: string;
    physical_state: string;
    physical_zip: string;
    physical_country_id: string;
    same_mail_and_physical_address: boolean;
    state: string;
    zip: string;
  }[];
  primary_location_id: number;
  primary_location: {
    building_type: string;
    city_id: string;
    created_at: string;
    custom_field_values: {
      custom_field_id: string;
      custom_field_name: string;
      custom_field_type: unknown;
      custom_field_value_id: string;
      value_address: {
        address: string;
        address2: string;
        attn: string;
        city: string;
        full: string;
        id: string;
        state: string;
        zip: string;
      };
      value_boolean: boolean;
      value_datetime: string;
      value_keyword: string;
      value_number: number;
      value_text: string;
      value_text_array: {
        value: string;
      }[];
    }[];
    deactivated_at: string;
    id: string;
    location_address: {
      address: string;
      address2: string;
      attn: string;
      city: string;
      full: string;
      state: string;
      zip: string;
    };
    location_name: string;
    lot_size: string;
    owner_address: {
      address: string;
      address2: string;
      attn: string;
      city: string;
      full: string;
      state: string;
      zip: string;
    };
    owner_email: string;
    owner_name: string;
    owner_phone: string;
    parcel_number: string;
    updated_at: string;
    year_built: string;
    zoning: string;
  };
  assignee_ids: string[];
  assignees: {
    address: string;
    city: string;
    departmentId: number;
    email: string;
    firstName: string;
    full_name: string;
    lastName: string;
    phone: string;
    state: string;
    type: string;
    zip: string;
  }[];
  renewal_status: string;
  workflow_steps: {
    title: string;
  }[];
  active_workflow_steps: {
    title: string;
    step_type: string;
  }[];
  permits_attachments_count: 0;
  renewable: boolean;
  renewal_notify_mail: string;
  non_renewal_note: string;
  non_renewal_reason: string;
  issued_child: {
    confirmation_number: string;
    id: number;
    issued_at: string;
    reservation_number: string;
  };
  submitted_child: {
    confirmation_number: string;
    id: number;
    issued_at: string;
    reservation_number: string;
  };
}
export function searchPermits(headers: any) {
  return async (_key: unknown, options: PermitsSearchOptions) => {
    return fetch(
      `${AppSettings.SEARCH_API_URL}/permits?${queryString.stringify(options, { arrayFormat: "bracket" })}`,
      {
        method: "GET",
        headers: headers,
      },
    ).then(async (response) => {
      const json = await response.json();
      // TODO: This type def is probably out of date with the permit index -
      return json as PermitsSearchData[];
    });
  };
}

//For manually connecting a renewal permit
export const getRenewalPermits =
  (networkHeaders: any) =>
  (query: {
    searchString: string;
    size: number;
    permitsTypeId: string;
    startedAt: number | string | null | undefined;
  }) =>
    fetch(
      `${AppSettings.SEARCH_API_URL}/permits/renewal_permits?${queryString.stringify(decamelizeKeys(query || {}, "_"), {
        arrayFormat: "bracket",
      })}`,
      {
        method: "GET",
        headers: networkHeaders,
      },
    ).then((res: any) => {
      if (res.status === 200) {
        return res.json();
      }
      if (res.error) throw new Error(res.error);
      throw new Error(`Query failed with status ${res.status}`);
    });

export const fetchTransactionLogs = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  searchParams.transaction_aggregates = true;
  return fetch(`${AppSettings.SEARCH_API_URL}/transactions`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());
};

export const fetchInspections = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/inspections`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());
};

export const fetchPayouts = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) =>
  fetch(`${AppSettings.SEARCH_API_URL}/payouts`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());

export const postPersonSearch = (networkHeaders: any) => (gql: GQL) =>
  fetch(`${AppSettings.SEARCH_API_URL}/person`, {
    method: "POST",
    body: JSON.stringify({ gql }),
    headers: networkHeaders,
  }).then((res) => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Query failed with status ${res.status}`);
  });
